import { useQueryState } from '../useQueryState';

const SEARCH_STRING_QUERY_PARAM_KEY = 'search';

export const useSearchString = () => {
  const { query, setQuery } = useQueryState(SEARCH_STRING_QUERY_PARAM_KEY);

  return { searchString: query, setSearchString: setQuery };
};
